import { h } from 'preact'
import classNames from 'classnames'

interface SelectSingleOptionProps {
  option: string
  optionName: string
  handleSetClickedOption: (option: string) => void
  isWithFlags?: boolean
  flagClassName?: string
  subLabel?: string
  description?: string
}

export const SelectSingleOption = ({
  option,
  optionName,
  handleSetClickedOption,
  isWithFlags = false,
  flagClassName,
  subLabel,
  description,
}: SelectSingleOptionProps) => {
  return (
    <div
      className={classNames('preact-select__option', {
        'preact-select__option--with-sublabel': !!subLabel,
        'preact-select__option--two-line': !!description,
      })}
      role="option"
      aria-selected={false}
      tabIndex={0}
      onClick={() => handleSetClickedOption(option)}
    >
      {isWithFlags && (
        <span
          className={`preact-select__option-flag ${
            flagClassName || `icon-currency-round-${option} icon-currency-round-${option}-dims`
          }`}
        />
      )}
      <span className={`preact-select__option-name ${isWithFlags ? 'preact-select__option-name--with-flag' : ''}`}>
        {optionName}
      </span>
      {subLabel && <span className="preact-select__option-sublabel">{subLabel}</span>}
      {description && <span className="preact-select__option-description">{description}</span>}
    </div>
  )
}
